import * as React from 'react';
import { Form, Grid, Input, Popup } from 'semantic-ui-react';

import listaComponentes from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/ListaComponentes';

import { formatearTelefono, mantenerSoloNumeros } from '../utils/formateadores';

const marginTop4d5exStyle = { marginTop: '4.5ex' };

export interface Datos {
    nombre: string;
    codArea: string;
    numero: string;
    whatsApp: boolean;
}

export const inicial: Datos = {
    nombre: '',
    codArea: '',
    numero: '',
    whatsApp: false,
};

interface Props {
    requerido: boolean;
}

const ListaTelefonos = listaComponentes<Datos, Props>(props => {
    const { requerido, item, onChange, onDelete } = props;

    return (
        <Form.Group>
            <Form.Field width='4' required={requerido}>
                <label>Nombre</label>
                <Input
                    placeholder='Trabajo'
                    value={item.nombre}
                    onChange={(_e, { value }) => {
                        onChange({ ...item, nombre: value });
                    }}
                    required={requerido}
                />
            </Form.Field>
            <Form.Field width='5' required={requerido}>
                <label>Número de teléfono</label>
                <Grid>
                    <Grid.Column width='7'>
                        <Input
                            label='+56'
                            placeholder='9'
                            value={item.codArea}
                            onChange={(_e, { value }) => {
                                onChange({ ...item, codArea: mantenerSoloNumeros(value) });
                            }}
                            required={requerido}
                        />
                    </Grid.Column>
                    <Grid.Column width='9'>
                        <Input
                            placeholder='1234 5678'
                            value={item.numero}
                            onChange={(_e, { value }) => {
                                onChange({ ...item, numero: formatearTelefono(value) });
                            }}
                            required={requerido}
                        />
                    </Grid.Column>
                </Grid>
            </Form.Field>
            <Form.Checkbox
                label='WhatsApp'
                style={marginTop4d5exStyle}
                checked={item.whatsApp}
                onChange={(_e, { checked }) => {
                    onChange({ ...item, whatsApp: checked || false });
                }}
            />

            <Popup
                trigger={
                    <Form.Button
                        type='button'
                        circular
                        compact
                        icon='close'
                        color='red'
                        size='tiny'
                        style={marginTop4d5exStyle}
                        onClick={onDelete}
                    />
                }
                content='Quitar este teléfono.'
                position='right center'
                hideOnScroll
            />
        </Form.Group>
    );
});

export default ListaTelefonos;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Telefonos/componentes/ListaTelefonos.tsx